import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InviteManagerComponent } from "./invite-manager.component";
import { InviteManagerAuthResolver } from "./invite-manager-auth-resolver.service";

const routes: Routes = [
  {
    path: "", // path is "invites"
    component: InviteManagerComponent,
    resolve: {
      isAuthenticated: InviteManagerAuthResolver,
    },
    data: {
      title: "Invite Manager",
      icon: "ti-check-box",
      caption:
        "Find, accept, reject or track all your invites to uMuzis and nDaba's",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InviteManagerRoutingModule {}
